import React, { useRef } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useSnackbar } from "notistack";

function ContactForm() {
  const { enqueueSnackbar } = useSnackbar();

  const formRef = useRef<HTMLFormElement | null>(null);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // No backend is configured for this static site, so the form opens a
    // compose window addressed to all three Ming Stone mailboxes. The
    // inquiry is only delivered when the visitor presses Send there.
    const formData = new FormData(e.currentTarget);
    const name = String(formData.get("inquiry[name]") ?? "");
    const email = String(formData.get("inquiry[email]") ?? "");
    const subject = String(formData.get("inquiry[subject]") ?? "");
    const message = String(formData.get("inquiry[message]") ?? "");
    const recipients = [
      "info@mingstone.com",
      "mingstonesupplier@gmail.com",
      "mingstone-yantai@163.com",
    ].join(",");
    const body = `Name: ${name}\nEmail: ${email}\n\n${message}`;
    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
        recipients
      )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`,
      "_blank",
      "noopener"
    );
    enqueueSnackbar(
      "Gmail compose has been opened addressed to all three Ming Stone mailboxes. Please press Send in Gmail to deliver this inquiry.",
      { variant: "success" }
    );
  };

  return (
    <>
      <Typography variant="h5">Contact Us</Typography>

      <Box
        component="form"
        ref={formRef}
        onSubmit={handleSubmit}
        sx={{
          "& > :not(style)": { my: 2 },
        }}
        autoComplete="off"
      >
        <Stack spacing={2} direction="row" sx={{ marginBottom: 4 }}>
          <TextField
            label="Name"
            variant="standard"
            name="inquiry[name]"
            required
            fullWidth
          />
          <TextField
            label="Email"
            variant="standard"
            name="inquiry[email]"
            required
            fullWidth
          />
        </Stack>

        <TextField
          label="Subject"
          variant="standard"
          name="inquiry[subject]"
          required
          fullWidth
        />
        <TextField
          label="Message"
          variant="standard"
          name="inquiry[message]"
          required
          fullWidth
          multiline
          rows={5}
        />

        <Box mt={2}>
          <Typography variant="caption">
            Send via Gmail opens Gmail in your browser, addressed to
            info@mingstone.com, mingstonesupplier@gmail.com and
            mingstone-yantai@163.com — no email app needed on your device.
            We'll get back to you as soon as possible.
          </Typography>
        </Box>

        <Button variant="contained" color="brand" type="submit" fullWidth>
          Send via Gmail
        </Button>
      </Box>
    </>
  );
}

export default ContactForm;
